module.exports = __webpack_public_path__ + "static/media/send-blue.368a8659.svg";